import UsersList from './users-list'

export default UsersList